import { Injectable } from '@angular/core';
import {
    HttpInterceptor,
    HttpRequest,
    HttpHandler,
    HttpEvent,
    HttpErrorResponse,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { endPoints } from '../api-end-points';
import { AuthService } from '../services/auth.service';
import { ApiBaseUrlService } from '../services/api-base-url.service';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  private readonly protectedGetPrefixes = [
    endPoints.GET_USER_BY_ID,
    endPoints.GET_TEST_SERIES_LINK,
    endPoints.GET_CLASS_LINK,
    endPoints.GET_ORDER_BY_USERID.replace(/\?$/, ''),
    endPoints.GET_ADDRESS_DETAILS,
    endPoints.GET_ADDRESS_DETAILS_FILTER.replace(/\?$/, ''),
    endPoints.GET_SUBSCRIPTION_PACKAGE,
    endPoints.GET_CUSTOMIZED_PACKAGE_BY_USERID,
    endPoints.GET_PROCTUR_TOKEN,
    endPoints.USER_DETAILS,
  ];

  private readonly protectedWritePrefixes = [
    endPoints.USER_DETAILS,
    endPoints.USER_EDIT_DETAILS,
    endPoints.UPDATE_USER_DETAILS,
    endPoints.CHANGE_PASSWORD.replace(/\/$/, ''),
    endPoints.USER_SUBSCRIPTION,
    endPoints.PURCHASE_SUBSCRIPTION,
    endPoints.PACKAGE_ORDER,
    endPoints.PACKAGE_ORDER_DETAILS,
    endPoints.CREATE_TEMP_PACKAGE,
    endPoints.CREATE_TRANSACTION,
   // endPoints.CREATE_QUESTION,
    endPoints.UPDATE_QUESTION,
    endPoints.CREATE_ANSWER,
    endPoints.UPADTE_PHONE_AND_GRADE.split('?')[0],
    endPoints.DELETE_FILE_FROM_CDN,
    endPoints.UPLOAD_FORUM_FILE,
    endPoints.UPLOAD_FORUM_FILE_V1,
  ];

    private readonly publicPrefixes = [
    endPoints.AUTH_SEND_EMAIL_OTP,
    endPoints.AUTH_VERIFY_EMAIL_OTP,
    endPoints.AUTH_RESEND_EMAIL_OTP,
    endPoints.AUTH_SEND_OTP,
    endPoints.AUTH_VERIFY_OTP,
    endPoints.AUTH_RESEND_OTP,
    endPoints.AUTH_FIREBASE_LOGIN,
    endPoints.AUTH_FIREBASE_LOGIN_LEGACY,
    endPoints.ADD_USER,
    endPoints.lOGIN_USING_EMAIL_ID,
    endPoints.SAVE_GOOGLE_SIGNIN_RESPONSE,
    endPoints.CHECK_PHONE_NO,
    endPoints.CHECK_EMAIL_ID,
    endPoints.CHECK_USER,
    endPoints.FORGOT_PASSWORD_USING_EMAIL_ID,
    endPoints.ENCRYPT_OBJECT,
    endPoints.DECRYPT_OBJECT,
    endPoints.UPLOAD_FILE_ON_CDN,
  ];

  constructor(
    private authService: AuthService,
    private apiBaseUrlService: ApiBaseUrlService
  ) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const token = this.authService.getAccessToken();
    const baseUrl = this.apiBaseUrlService.getBaseUrl();
    let cloned = req;

    if (req.url.startsWith(baseUrl)) {
      const headersToSet: Record<string, string> = {};

      if (!req.headers.has('X-Portal')) {
        headersToSet['X-Portal'] = this.shouldUseAdminPortal(req) ? 'admin' : 'frontend';
      }

      if (token && this.shouldAttachToken(req) && !req.headers.has('Authorization')) {
        const tokenType = this.authService.getTokenType() || 'Bearer';
        headersToSet['Authorization'] = `${tokenType} ${token}`;
      }

      if (Object.keys(headersToSet).length > 0) {
        cloned = req.clone({
          setHeaders: headersToSet,
        });
      }
    }

    return next.handle(cloned).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error?.status === 401 || error?.status === 404) {
          console.warn('[TokenInterceptor]', error.status, req.method, req.url);
        }

        return throwError(() => error);
      })
    );
  }

  private shouldAttachToken(req: HttpRequest<any>): boolean {
    const baseUrl = this.apiBaseUrlService.getBaseUrl();
    if (!req.url.startsWith(baseUrl)) {
      return false;
    }

    const path = req.url.replace(baseUrl, '');
    if (this.publicPrefixes.some((prefix) => path.startsWith(prefix))) {
      return false;
    }

    if (req.method === 'GET') {
      return this.protectedGetPrefixes.some((prefix) => path.startsWith(prefix));
    }

    return this.protectedWritePrefixes.some((prefix) => path.startsWith(prefix));
  }

  private shouldUseAdminPortal(req: HttpRequest<any>): boolean {
    const baseUrl = this.apiBaseUrlService.getBaseUrl();
    const path = req.url.replace(baseUrl, '');

    return path.startsWith(endPoints.UPLOAD_FORUM_FILE) || path.startsWith(endPoints.UPLOAD_FORUM_FILE_V1);
  }
}
